<template>
  <v-card light class="cursor--order">
    <v-card-text>
      <p class="body-1 font-weight-regular" v-html="card.message"></p>
      <v-chip>{{order}}</v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src

export default {
  name: "UserServiceCard",
  data() {
    return {
      open: false,
    };
  },
  props: {
    card: Object,
    all: Array,
  },
  computed: {
    message() {
      return this.item ? this.item.message : null;
    },
    order() {
      return this.card ? parseInt(this.card.index) + 1 : 0;
    },
    item() {
      return this.all.find((x) => x.id == this.card.id);
    },
  },
  methods: {},
};
</script>
